<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />

        <avs-createButton
          :spantext="$t('actions.create', { entity: $t('commons.notification').toLowerCase() })"
          menu
          :name="$t('actions.new_female', { entity: $t('commons.notification').toLowerCase() })"
          @click="handleOpenEditDialog()"
        >
        </avs-createButton>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        dense
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="items"
        :items-per-page="-1"
        :search="search"
        item-key="id"
        @dblclick:row="
          ($event, { item }) => {
            if (allow.duplicate(item)) {
              handleOpenEditDialog(item)
            }
          }
        "
      >
        <template #item.notification_object="{ item }">
          {{ truncateText(item.notification_object, 25) }}
        </template>
        <!-- <template v-slot:item.users="{ item }">
          <span
            v-for="user in item.users"
            :key="user.id"
            :label="false"
          >
            {{ user.email }},
          </span>
        </template> -->
        <template v-slot:item.users="{ item }">
          <v-chip>
            <v-icon left>mdi-account-multiple-outline</v-icon>
            {{ item.users.length }}
            {{
              item.users.length > 1
                ? $t("commons.user.name_plural")
                : $t("commons.user.name_singular")
            }}
          </v-chip>
        </template>

        <template #item.description="{ item }">
          <span v-html="truncateText(item.description, 25)"></span>
        </template>
        <template #item.created_at="{ item }">
          {{ toDatetime(item.created_at) }}
        </template>
        <template v-slot:item.status="{ item }">
          <avs-chip :label="false">
            {{ item.status }}
          </avs-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <!-- <avs-editButton
              @click.stop="handleOpenEditDialog(item)"
              :spantext="$t('actions.edit', { entity: $t('commons.fieldtype').toLowerCase() })"
            /> -->
            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-eye'"
              label
              fab
              small
              @click.stop="handleOpenEditDialog(item)"
              :spantext="$t('actions.open', { entity: $t('commons.fieldtype').toLowerCase() })"
            />

            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="$t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })"
            />
          </div>
        </template>
      </v-data-table>
      <!-- v-html="document.description" -->

      <v-dialog
        v-model="editDialogIsOpen"
        width="60vw"
      >
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Notification"
      />
    </template>
  </avs-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
import { InternalNotificationService } from "@/services"
import { mkUnique } from "@/utils/validator"

import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue"
import NotificationEditor from "@/components/ri3/notifications/NotificationEditor.vue"

export default {
  name: "InternalNotification",
  components: { DeleteDialog, NotificationEditor },
  created() {
    this.fetchFieldTypes()
  },
  computed: {
    hasUniqueName: {
      get() {
        const names = this.items.filter(e => e.name !== this.selectedItem?.name).map(e => e.name)
        return mkUnique(names, "name")
      }
    },
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("commons.object"),
          value: "notification_object",
          // class: "min-width-150",
          sortable: true
        },
        {
          text: this.$t("commons.recipient"),
          value: "users",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: this.$t("commons.message"),
          value: "description",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: this.$t("commons.created_at"),
          value: "created_at",
          sortable: true,
          filterable: false
        },
        {
          text: this.$t("commons.action"),
          value: "actions",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      isEditable: true,
      items: [],
      search: "",

      // basecomponents: Object.values(COMPONENT_ENUM),
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined
    }
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      InternalNotificationService.getAll(this, this.project.id)
        .then(response => {
          this.items = response
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + "..." : text
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialogIsOpen = true
    },
    handleOpenEditDialog(item) {
      this.selectedItem = undefined
      this.isEditable = true
      if (item) {
        this.selectedItem = item
        this.isEditable = false
      }
      this.handleOpenEditDialogByComponent()
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true
      this.editDialogContent = "NotificationEditor"
    },
    handleCancel() {
      this.selectedItem = undefined
      this.deleteDialogIsOpen = false
      this.editDialogIsOpen = false
      this.editDialogContent = null
    },
    handleError(message) {
      this.send(message || this.$t("messages.error.failed_admin", { role: "INSPECTOR" }), "error")
    },
    handleSuccess() {
      this.handleCancel()
      this.$nextTick(() => {
        this.fetchFieldTypes()
        this.send(this.$t("messages.success.operation"), "success")
      })
    },
    handleDelete() {
      InternalNotificationService.delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess()
        })
        .catch(error => {
          const message = error?.response.data?.state
          this.handleError(message)
        })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
